import React from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import ScrollToTop from '../../components/shared/ScrollToTop';
import { SigningContextProvider } from '../../signingContext/signingContext';
import AvtaleGiroMoveContext from './context/AvtaleGiroMoveContext';
import {
    MoveAvtaleGiroInitialSigning,
    ChooseAvtaleGiroPaymentAccount,
    ChooseAgreements,
    MoveAvtaleGiroSummary,
} from './pages';
import ROUTES from './routes';

import './MoveAvtaleGiro.scss';

const MoveAvtaleGiro = () => (
    <div className="sgw-content move-avtalegiro">
        <SigningContextProvider analyticsCategory="move-avtalegiro">
            <AvtaleGiroMoveContext>
                <Router>
                    <ScrollToTop />
                    <Routes>
                        <Route path={ROUTES.summary} Component={MoveAvtaleGiroSummary} />
                        <Route path={ROUTES.chooseAgreements} Component={ChooseAgreements} />
                        <Route path={ROUTES.chooseDebitAccount} Component={ChooseAvtaleGiroPaymentAccount} />
                        <Route path="/" Component={MoveAvtaleGiroInitialSigning} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </Router>
            </AvtaleGiroMoveContext>
        </SigningContextProvider>
    </div>
);

export default MoveAvtaleGiro;
